export default "__VITE_ASSET__BFn5zin1__"